import React, { useState } from 'react'
import { Dialog } from 'components/ds'

import { CancelSubscriptionModalStepOne } from './CancelSubscriptionModalStepOne'
import { CancelSubscriptionModalStepTwo } from './CancelSubscriptionModalStepTwo'
import { CancelSubscriptionModalStepThree } from './CancelSubscriptionModalStepThree'

type CancelSubscriptionModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const CurrentStep = ({
  currentStep,
  onNext,
}: {
  currentStep: number
  onNext: () => void
}) => {
  switch (currentStep) {
    case 1:
      return <CancelSubscriptionModalStepOne onNext={onNext} />
    case 2:
      return <CancelSubscriptionModalStepTwo onNext={onNext} />
    case 3:
      return <CancelSubscriptionModalStepThree />
  }
}

export const CancelSubscriptionModal = ({
  open,
  onOpenChange,
}: CancelSubscriptionModalProps) => {
  const [currentStep, setCurrentStep] = useState(1)

  function handleOpenChange(open: boolean) {
    onOpenChange(open)
    setCurrentStep(1)
  }

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Content maxWidth="600px">
        <CurrentStep
          currentStep={currentStep}
          onNext={() => setCurrentStep(currentStep + 1)}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
